<template>
  <div>
    <Card style="padding-bottom: 40px">
      <div class="searchBox">
        <Row>
          <Form :label-width="100">
            <Col :span="5">
              <FormItem label="事件名称">
                <Input v-model="eventForm.eventTitle" @on-blur="getInformationReceivingData"
                       clearable
                       @on-clear.once="getInformationReceivingData('clean')"></Input>
              </FormItem>
            </Col>
            <Col :span="5">
              <FormItem label="事件状态">
                <Select transfer v-model="eventForm.status" clearable
                        @on-clear.once="getInformationReceivingData('clean')"
                        @on-change="getInformationReceivingData">
                  <Option v-for="(item,index) in eventStatusList" :value="item.id" :label="item.name"
                          :key="index"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="5">
              <FormItem label="事件类型">
                <Select transfer v-model="eventForm.eventType" clearable
                        @on-clear.once="getEventCategoryListAndGetEventData('clean')"
                        @on-change="getEventCategoryListAndGetEventData">
                  <Option v-for="(item,index) in eventTypeList" :value="item.id" :label="item.name"
                          :key="index"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="5">
              <FormItem label="事件类别">
                <Select v-model="eventForm.category" @on-change="getInformationReceivingData">
                  <Option v-for="(item,index) in categoryList" :key="index" :value="item.id"
                          :label="item.name"></Option>
                </Select>
              </FormItem>
            </Col>
          </Form>
        </Row>
      </div>
      <Table
        :loading="InformationReceivingLoading"
        :columns="InformationReceivingColumns"
        :data="InformationReceivingData"
        :highlight-current-row="true"
        height="500"
      >
        <template #action="{ row, index }">
          <el-button v-if="row.currentLink!==10" :disabled="row.eventLevel !== null||curArea !== row.deptIndexCode"
                     size="small" type="text"
                     @click="handleDown(row)">处置完成
          </el-button>
          <el-button v-if="row.is_handle === '0'" size="small" type="text" @click="gotoEmergeResponse(row)">查看
          </el-button>
          <el-button v-else-if="row.isDrill!=='0'" size="small" type="text" @click="openExportTable(row)">导出
          </el-button>
        </template>
      </Table>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            :total="InformationReceivingTotal"
            :page-size="InformationReceivingPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="InformationReceivingCurrentPage"
            @on-change="InformationReceivingPageChange"
            @on-page-size-change="InformationReceivingPageSizeChange"
      ></Page>
    </Card>
    <!--    <div v-if="seleRow">-->
    <!--      <emergency-response :event-info="seleRow"></emergency-response>-->
    <!--    </div>-->
    <Modal
      v-model="exportModal"
      title="导出"
      :width="550"
    >
      <Card dis-hover :bordered="false">
        <!--        {{ exportList }}-->
        <CheckboxGroup v-model="exportList" @on-change="selectTable">
          <Checkbox v-for="(item, index) in formList" :key="index" :label="index">
            {{ item.name }}
          </Checkbox>
        </CheckboxGroup>
      </Card>
      <div slot="footer">
        <Button type="primary" :loading="exportLoading" @click="exportToWord">导出</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {monitoringColumns} from './js/newInformation.js'
import {exportWord, getBase64Sync} from '@/utils/exportBriefDataDocx'
import EmergencyResponse from '@/views/emergencyResponse/emergencyResponse.vue'

export default {
  components: {EmergencyResponse},
  data() {
    return {
      seleRow: null,
      exportModal: false,
      exportList: [],
      exportEventImgPath: [],
      formList: [
        {name: '接警单', label: 'alarmForm'},
        {name: '专家会商信息采集单', label: 'consultationForm'},
        {name: '应急处置信息采集单', label: 'responseForm'},
        {name: '合打单', label: 'combinedForm'}
      ],
      exportLoading: false,
      eventForm: {
        eventTitle: '',
        eventStatus: '',
        eventType: ''
      },
      categoryList: [],// 事件类别列表
      eventTypeList: [],// 事件类型列表
      eventStatusList: [],// 事件状态列表
      InformationReceivingLoading: true,
      InformationReceivingTotal: 0,
      InformationReceivingColumns: monitoringColumns,
      InformationReceivingData: [],
      InformationReceivingPageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      InformationReceivingCurrentPage: 1,
      curArea: ''
    }
  },
  mounted() {
    this.getInformationReceivingData()
    this.getEventStatusList()
    this.getEventTypeList()
    this.getUserData()
  },
  methods: {
    getEventCategoryListAndGetEventData(flag) {
      console.log(flag)
      if (flag === 'clean' || !flag) {
        this.eventForm.category = null
        this.getInformationReceivingData()
      } else {
        this.getEventCategoryListList()
        this.getInformationReceivingData()
      }
    },
    // 获取事件类别列表
    getEventCategoryListList(item) {
      this.$http.get(`/api/getEventCategorysList?typeId=${this.eventForm.eventType}`).then(res => {
        if (res.status === 200) {
          this.categoryList = res.data
        }
      })
    },
    // 处理完成
    handleDown(row) {
      let request = {
        id: row.id,
        currentLink: 10
      }
      this.$http.put(`/api/messageReceptions`, request).then(res => {
        if (res.status === 200) {
          this.$Message.success('操作成功')
          this.getInformationReceivingData()
        }
      })
    },
    getUserData() {
      this.$http.get('/api/getLowerLevelDepts').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curArea = res.data[0].indexCode
        }
      })
    },
    ok() {
      this.exportToWord()
    },
    cancel() {
      this.exportModal = false
    },
    gotoEmergeResponse(row) {
      console.log(row)
      this.seleRow = row
      this.$router.push({
        name: 'RoadEmergencyResponse',
        query: {
          id: row.id
        }
      })
    },
    //核查，补充小程序上报信息
    updateInfo(row) {
      this.$router.push({
        name: 'createAndEditNewInformation',
        params: {
          row: row,
          type: 2
        }
      })
    },
    // 导出
    openExportTable(row) {
      this.exportModal = true
      this.exportList = []
      this.exportInfo = row
      this.formatImgBase(row)
      this.getLinks(row)
    },
    formatImgBase(row) {
      let imgList = []
      if (row.eventImgPath !== null && row.eventImgPath !== '') {
        let paths = row.eventImgPath.split(';')
        // console.log(paths)
        for (var i = 0; i < paths.length; i++) {
          getBase64Sync(paths[i]).then(res => {
            // console.log("eventImgPath", res)
            imgList.push({
              url: res
            })
          })
        }
      }
      this.exportEventImgPath = imgList
    },
    selectTable(value) {
      // console.log(value)
      this.exportList = value
    },
    // 获取类型列表
    getEventTypeList() {
      this.$http.get(`/api/getEventTypesListByType?type=${2}`).then(res => {
        if (res.status === 200) {
          this.eventTypeList = res.data
        } else {
          this.$Message.error('获取事件类型列表失败')
        }
      })
    },
    // 获取状态列表
    getEventStatusList() {
      // this.eventStatusList = [
      //   {id: 0, name: '处置中'},
      //   {id: 1, name: '事件已启动'},
      //   {id: 2, name: '事件结束'},
      //   {id: 3, name: '已终止'}
      // ]
      this.$http.get('/api/eventStatuss').then(res => {
        // console.log(res)
        this.eventStatusList = res.data.data
      })
    },
    // 获取信息接收数据
    getInformationReceivingData(value) {
      if (value === 'clean') {
        this.eventForm.status = null
        this.eventForm.eventType = null
        this.eventForm.eventTitle = null
      }
      if (this.eventForm.status === '') {
        this.eventForm.status = null
      }
      if (this.eventForm.eventType === '') {
        this.eventForm.eventType = null
      }
      if (this.eventForm.eventTitle === '') {
        this.eventForm.eventTitle = null
      }
      let reqData = {
        page: this.InformationReceivingCurrentPage,
        size: this.InformationReceivingPageSize,
        ...this.eventForm,
        reportingChannels: 2
      }
      this.InformationReceivingLoading = true
      this.$http.post('/api/getMessageList', reqData).then(res => {
        this.InformationReceivingData = res.data.data
        this.InformationReceivingTotal = res.data.recordsTotal
        this.InformationReceivingLoading = false
      })
    },
    // 新建信息
    createNewInformation() {
      this.$router.push({name: 'createAndEditNewInformation'})
    },
    InformationReceivingPageChange(page) {
      this.InformationReceivingCurrentPage = page
      this.getInformationReceivingData()
    },
    InformationReceivingPageSizeChange(pageSize) {
      this.InformationReceivingPageSize = pageSize
      this.getInformationReceivingData()
    },
    getLinks(exportInfo) {
      let params = {
        messageId: exportInfo.id,
        eventLevel: exportInfo.eventLevel,
        eventSeverity: exportInfo.eventSeverity,
        indexCode: exportInfo.deptIndexCode
      }
      let data = exportInfo
      this.$http.post('/api/getLinks', params).then(res => {
        // console.log(res)
        let list = res.data.data
        for (let i = 0; i < list.length; i++) {
          if (list[i].information !== null) {
            var info = list[i].information.split(';')
            for (let j = 0; j < info.length; j++) {
              const obj = info[j].split('_')
              data[obj[0]] = obj[1]
              if (obj[0] === 'eventCheckImg' || obj[0] === 'eventSiteBeforeImg' || obj[0] === 'eventSiteAfterImg') {
                let list = JSON.parse(obj[1])
                data[obj[0]] = list.map(item => {
                  // console.log(item)
                  getBase64Sync(item.url).then(res => {
                    // console.log(res)
                    item.url = res
                  })
                  return item
                })
              }
            }
          }
        }
        // console.log(data)
        this.exportInfo = {...data}
      })
    },
    //导出word
    async exportToWord() {
      if (this.exportList.length > 0) {
        this.exportLoading = true
        //导出图片
        let imgSize = {
          // 控制导出的word图片大小
          proposalPath: [200, 200]
        }
        let data = {}
        await this.formatData().then(res => {
          // console.log(res)
          data = res
          console.log('data', data)
          this.exportList.forEach(i => {
            // console.log(this.formList[i])
            exportWord(`./wordTemplate/${this.formList[i].label}.docx`, data, `${this.formList[i].name}.docx`, imgSize)
          })
        })
        this.exportLoading = false
        this.exportModal = false
      } else {
        this.$Message.warning('请选择导出文件！')
        this.exportModal = true
      }
    },
    formatData() {
      return new Promise((resolve, reject) => {
        let data = this.exportInfo
        data.eventReceptionTime = this.$moment(this.exportInfo.eventReceptionTime).format('YYYY-MM-DD HH:mm')
        data.eventImgPath = this.exportEventImgPath
        resolve(data)
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "css/InformationReceiving.less";
</style>
